import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ShoppingBag } from "@phosphor-icons/react";
import api from "@/lib/api";

const CITIES = ["Cape Town", "Johannesburg", "Durban", "Pretoria", "Roodepoort", "Sandton", "Stellenbosch", "Port Elizabeth"];

export default function SocialProofToast() {
  const [orders, setOrders] = useState([]);
  const [current, setCurrent] = useState(null);

  useEffect(() => {
    api.get("/orders/recent-public").then((r) => setOrders(r.data)).catch(() => {});
  }, []);

  useEffect(() => {
    if (orders.length === 0) return;
    let i = 0;
    let hideT;
    const cycle = () => {
      const o = orders[i % orders.length];
      const city = CITIES[Math.floor(Math.random() * CITIES.length)];
      setCurrent({ ...o, city });
      hideT = setTimeout(() => setCurrent(null), 5000);
      i += 1;
    };
    const first = setTimeout(cycle, 6000);
    const cycler = setInterval(cycle, 12000);
    return () => {
      clearTimeout(first);
      clearTimeout(hideT);
      clearInterval(cycler);
    };
  }, [orders]);

  return (
    <AnimatePresence>
      {current && (
        <motion.div
          key={current.first_name + current.item_name + Math.random()}
          initial={{ opacity: 0, y: 20, x: -30 }}
          animate={{ opacity: 1, y: 0, x: 0 }}
          exit={{ opacity: 0, y: 20, x: -30 }}
          transition={{ duration: 0.35 }}
          data-testid="social-proof-toast"
          className="fixed bottom-6 left-6 z-40 max-w-[320px] border border-white/15 bg-[#0d0d0d]/95 backdrop-blur px-4 py-3 shadow-2xl"
        >
          <div className="flex items-start gap-3">
            <div className="flex h-8 w-8 shrink-0 items-center justify-center bg-[#FF5A1F] rounded-sm">
              <ShoppingBag size={16} weight="bold" color="#050505" />
            </div>
            <div className="min-w-0 flex-1">
              <div className="text-xs text-white/90">
                <b>{current.first_name}</b> from <b className="text-[#00FFC2]">{current.city}</b> just ordered
              </div>
              <div className="mt-0.5 text-[11px] text-white/60 truncate">{current.item_name}</div>
              <div className="mt-1 text-[10px] font-label text-white/40">A few minutes ago</div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
